export default [
  {
    path: '/admin/reports/yearly-expense-items',
    name: 'yearly-expense-item',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/expense/yearly-expense-item')
  }
]
